import { NET_ID } from ".";

// 根据链id返回对应的代币符号
export function getSymbol() {
  if (NET_ID == 97 || NET_ID == 56) {
    return 'BNB'
  }
  if (NET_ID == 84532 || NET_ID == 8453) {
    return 'BASE_ETH'
  }

  return 'SUI'
}